import React from 'react';
import { ActionIcon } from '@mantine/core';
import { Plus } from 'lucide-react';
import './FloatingAddButton.css';

interface FloatingAddButtonProps {
  onClick: () => void;
  isVisible?: boolean;
}

export const FloatingAddButton: React.FC<FloatingAddButtonProps> = ({ onClick, isVisible = true }) => {
  return (
    <ActionIcon
      className={`floating-add-button ${isVisible ? 'visible' : 'hidden'}`}
      onClick={onClick}
      size={56}
      radius="xl"
      variant="filled"
      color="blue"
      aria-label="Add new task"
      style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
    >
      <Plus size={28} />
    </ActionIcon>
  );
};
